import { IDomainResource } from '../Resource';
import { IBackboneElement } from '../BackboneElement';
import { IAddress } from '../Address';
import { IContactPoint } from '../ContactPoint';
import { IHumanName } from '../HumanName';
import { ICodeableConcept } from '../CodeableConcept';
import { IIdentifier } from '../Identifier';
import { IReference } from '../Reference';
import { date, AdministrativeGender } from '../Primitives';
import { IAttachment } from '../Attachment';
import { IPeriod } from '../Period';

export type PractitionerType = 'Practitioner';

export const isPractitioner = (
  resource: object | null | undefined,
): resource is IPractitioner =>
  !!resource && (resource as IPractitioner).resourceType === 'Practitioner';

export const createPractitioner = (
  firstName: string,
  lastName: string,
  email: string,
  gender: AdministrativeGender,
  id?: string,
): IPractitioner => {
  const practitioner: IPractitioner = {
    resourceType: 'Practitioner',
    name: [
      {
        family: lastName,
        given: [firstName],
        use: 'official',
      },
    ],
    active: true,
    gender: gender,
    telecom: [
      {
        use: 'work',
        system: 'email',
        value: email,
      },
    ],
  };
  if (id) practitioner.id = id;

  return practitioner;
};

export interface IPractitionerQualification extends IBackboneElement {
  identifier?: IIdentifier[];
  code: ICodeableConcept;
  period?: IPeriod;
  issuer?: IReference;
}

export interface IPractitioner extends IDomainResource<PractitionerType> {
  identifier?: IIdentifier[];
  active?: boolean;
  name?: IHumanName[];
  telecom?: IContactPoint[];
  address?: IAddress[];
  gender?: AdministrativeGender;
  birthDate?: date;
  photo?: IAttachment[];
  qualification?: IPractitionerQualification[];
  communication?: ICodeableConcept[];
}
